<nav mat-tab-nav-bar>
  <a
    mat-tab-link
    [routerLink]="['./info']"
    routerLinkActive
    #rla1="routerLinkActive"
    [active]="rla1.isActive"
  >
    <mat-icon matListIcon>info</mat-icon>&nbsp;&nbsp;&nbsp;Informazioni
  </a>
  <a
    mat-tab-link
    [routerLink]="['./activities']"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive"
  >
    <mat-icon matListIcon>map</mat-icon>&nbsp;&nbsp;&nbsp;Attività
  </a>
  <a
    mat-tab-link
    [routerLink]="['./pois']"
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive"
  >
    <mat-icon matListIcon>place</mat-icon>&nbsp;&nbsp;&nbsp;Luoghi da Scoprire
  </a>
</nav>

<router-outlet></router-outlet>
